/**
 * Textos de `common` en español — la fuente. `en/common.ts` tiene que tener
 * exactamente las mismas claves (lo exige el tipo), así que una clave nueva
 * acá rompe el typecheck hasta que alguien la traduce.
 *
 * Interpolación con funciones, no con plantillas "{n}": el compilador revisa
 * los argumentos y cada idioma arma su propia gramática (plurales, orden).
 */
const common = {
  language: {
    /** aria-label del selector. */
    label: 'Idioma',
    es: 'ES',
    en: 'EN',
    esName: 'Español',
    enName: 'English',
  },
  shell: {
    logout: 'Salir',
  },
  /** Los chips del cambio de superficie (`SurfaceSwitcher`). */
  surfaces: {
    /** aria-label del nav de chips. */
    switcherLabel: 'Cambiar de vista',
    candidate: 'Candidato',
    agency: 'Agencia',
    operator: 'Operador',
  },
  /** La barra del candidato (`JobApplyLayout`). */
  candidateShell: {
    /** aria-label del nav. */
    navLabel: 'Secciones',
    dashboard: 'Panel',
    messages: 'Mensajes',
    applications: 'Postulaciones',
    profile: 'Perfil',
    /** aria-label del contador de Mensajes. */
    unread: (n: number) => `${n} sin leer`,
    /** El pie de página de la app: la guía del puntaje y lo legal. */
    footerLabel: 'Más información',
    scoreGuide: 'Cómo funciona el puntaje de tu hoja de vida',
    terms: 'Términos',
    privacy: 'Privacidad',
  },
  /**
   * La franja de «Ver como» (lib/viewAs.ts): un operador mirando la app de un
   * candidato. Tiene que ser imposible no verla.
   */
  viewAs: {
    label: (who: string) => `Estás viendo la cuenta de ${who}`,
    someone: 'otra persona',
    readOnly: 'Solo lectura: nada de lo que toques acá se guarda ni se envía.',
    exit: 'Salir de la vista',
  },
  /**
   * El aviso de consentimiento de quien llega con el código de un socio (Ley
   * 1581): el socio ve su correo y el estado de su plan. Sale en el alta, ANTES
   * de que la atribución se estampe, y junto al precio rebajado.
   */
  referralConsent: {
    notice: (who: string) =>
      `Te registraste con el código de ${who}. Compartimos tu correo y el estado de tu plan con quien te invitó, para que pueda acompañarte.`,
  },
  auth: {
    login: {
      redirecting: 'Redirigiendo al inicio de sesión',
    },
    callback: {
      completing: 'Completando inicio de sesión',
      errorTitle: 'Error de autenticación',
      retry: 'Intentar de nuevo',
      /** Sólo si el error no trae mensaje propio. */
      failed: 'Authentication failed',
    },
  },
  sessionExpired: {
    title: 'Tu sesión expiró',
    body: 'No se guardó lo que estabas haciendo. Recarga la página para volver a entrar y vuelve a intentarlo.',
    reload: 'Recargar',
    hint: 'Si vuelve a pasar, cierra sesión y entra de nuevo.',
  },
  /**
   * Cuando la petición ni siquiera llega al servidor (`NetworkError` en
   * lib/api.ts). Antes la persona veía el «Failed to fetch» del navegador.
   */
  network: {
    offline: 'No pudimos conectarnos con TBit Jobs. Revisa tu conexión a internet e intenta de nuevo.',
  },
  errorBoundary: {
    title: 'Algo salio mal',
    body: 'Si tienes traduccion automatica activada en tu navegador, desactivala para esta pagina e intenta de nuevo.',
    reload: 'Recargar pagina',
  },
  /**
   * La burbuja de WhatsApp de TBit Jobs (`JobsWhatsappBubble`): el botón propio
   * de TBit con la línea del producto. El primer mensaje cambia según quién llega.
   */
  whatsappBubble: {
    buttonName: 'Escríbenos',
    brandSubtitle: 'Te responde nuestro asistente, a cualquier hora',
    callToAction: 'Abrir WhatsApp',
    welcome: 'Hola 👋 ¿Tienes una pregunta sobre TBit Jobs? Escríbenos por WhatsApp.',
    prefill: {
      candidates: 'Hola, tengo una pregunta sobre TBit Jobs',
      employers: 'Hola, quiero publicar vacantes en TBit Jobs',
      partners: 'Hola, quiero ser socio de TBit Jobs',
    },
  },
};

export default common;
